'use strict';

module.exports = function(app) {
    var formChange = require('./change')(app);

    formChange.formLabels();
    $('[data-init-plugin="select2"]').on('select2-close', function () {
        if (!$(this).attr('multiple')) {
            setTimeout(function() {
                $('.select2-container-active').removeClass('select2-container-active');
                $(':focus').blur();

                formChange.formLabels();
            }, 1);
        }
    });

    return app;
};
